import { formatStakeholdersListFromBE } from '../../formatters/stakeholdersListTransformers'

import { COUNTRY_ID, TITLE, TOTAL_ACTIVITY_HOURS, TOTAL_INVESTMENT } from '../../fields'
import { ASSUMPTION_NAME, ASSUMPTIONS, ATTRIBUTION, DEAD_WEIGHT, DISPLACEMENT, DROP_OFF } from '../../assumptionsFields'
import { STAKEHOLDERS_LIST } from '../../stakeholdersFields'

export const operationsCountriesOptions = [
  {
    value: 'GBR',
    label: 'United Kingdom'
  },
  {
    value: 'AUS',
    label: 'Australia'
  },
  {
    value: 'SAU',
    label: 'Saudi Arabia'
  }
]

export const initialAssumption = {
  [DROP_OFF]: 0,
  [DEAD_WEIGHT]: 0,
  [ATTRIBUTION]: 0,
  [DISPLACEMENT]: 0,
  [ASSUMPTION_NAME]: ''
}

export const getInitialValues = sroiReport => {
  return {
    [TITLE]: sroiReport?.[TITLE] || '',
    // general inputs section
    [COUNTRY_ID]: sroiReport?.payload?.[COUNTRY_ID] || '',
    [TOTAL_INVESTMENT]: sroiReport?.payload?.[TOTAL_INVESTMENT] || '',
    [TOTAL_ACTIVITY_HOURS]: sroiReport?.payload?.[TOTAL_ACTIVITY_HOURS] || '',
    // assumptions section
    [ASSUMPTIONS]: sroiReport?.payload?.[ASSUMPTIONS] || [],
    // stakeholder details section
    // Transform stakeholders from backend format to form format
    // (extract activity_levels from age groups and keep only totals in age_percentage)
    [STAKEHOLDERS_LIST]: formatStakeholdersListFromBE(sroiReport?.payload?.[STAKEHOLDERS_LIST])
  }
}
